/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from "react";
import { Loader } from "@googlemaps/js-api-loader";
import MarkerClusterer from "@googlemaps/markerclustererplus";

import { getLocalization } from "@utilities";

const AtmMap = (props) => {
  const {
    baseUrl,
    lat,
    lng,
    showGeolocation,
    localization,
    cultureCode,
    type,
    items,
    TabType,
    isToggled,
  } = props;

  // Funkce pro kontrolu šířky obrazovky
  const isSmallScreen = () => {
    return window.innerWidth < 992; // Vrátí true, pokud je šířka menší než 992px
  };

  useEffect(() => {
    let userMarker = null; // Hlavní user marker

    const loader = new Loader({
      apiKey: "AIzaSyB-BZCEoTrALP-YNfYeB7xaWmnmJaB2HRg",
      version: "weekly", // Můžete zde specifikovat konkrétní verzi API
    });

    const center = {
      lat: 49.8175, // Latitude pro Českou republiku
      lng: 15.473, // Longitude pro Českou republiku
    };

    loader
      .load()
      .then(() => {
        const requestData = {
          latitude: lat,
          longitude: lng,
          baseUrl: "",
          limit: 9999,
          offset: 0,
          cultureCode,
        };

        // Mapa se načetla, můžete provádět operace s mapou zde
        const map = new window.google.maps.Map(document.getElementById("mapAtm"), {
          center,
          zoom: 7, // Přiblížení mapy
          mapTypeControl: false,
          streetViewControl: false,
          zoomControl: true,
          fullscreenControl: false,
          clickableIcons: false,
        });

        const updateUserMarker = (position) => {
          if (userMarker) {
            userMarker.setPosition(position); // Aktualizace existujícího markeru
          } else {
            userMarker = new window.google.maps.Marker({
              position,
              title: localization.Branches_Atms_YourLocation,
              icon: {
                url: "/img/png/yourLocation.png",
                scaledSize: new window.google.maps.Size(32, 40),
              },
              map,
            });
          }
          map.setCenter(position);
          map.setZoom(12);
        };

        const clusterStyles = [
          {
            textColor: "white",
            url: "/img/svg/cluster.svg",
            height: 48, // Nastavení výšky ikony klastru
            width: 48, // Nastavení šířky ikony klastru
            display: "flex",
            lineHeight: 48,
          },
        ];

        let infoWindow;

        if (!isSmallScreen()) {
          infoWindow = new window.google.maps.InfoWindow({
            pixelOffset: new window.google.maps.Size(185, 180),
            disableAutoPan: true,
          });
        } else {
          infoWindow = new window.google.maps.InfoWindow({
            pixelOffset: new window.google.maps.Size(0, 0),
            disableAutoPan: false,
          });
        }

        // Zpracování dat z odpovědi
        const branchData = items;
        const markers = branchData?.map((location) => {
          const marker = new window.google.maps.Marker({
            position: { lat: location.latitude, lng: location.longitude },
            title: location.title,
            icon: type === "atms" ? "/img/svg/mapAtm.svg" : "/img/svg/mapBranche.svg",
            map,
          });

          marker.addListener("click", () => {
            // Nastavení obsahu info okna na základě údajů o lokalitě
            const content = `
            <div class="info-window">
              <div class="info-window__inner">
                <div class="info-window__title">
                <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.556 15.29V8.71h1.19v3.07l3.228-3.07h1.464l-3.322 3.167 3.46 3.412H9.973l-3.228-3.192v3.193h-1.19ZM17.744 13.36c0-.553-.288-.851-.908-.851h-3.254v1.693h3.106c.724 0 1.056-.316 1.056-.842Zm-.986-1.939c.55 0 .803-.385.803-.798 0-.456-.288-.824-.873-.824h-3.106v1.622h3.176Zm1.335.456c.576.298.907.851.907 1.483 0 1.088-.785 1.93-2.286 1.93h-4.336V8.71h4.31c1.204 0 2.076.737 2.076 1.851 0 .57-.244.983-.671 1.316Z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 7.017A5.767 5.767 0 0 1 7.017 1.25h9.966a5.767 5.767 0 0 1 5.767 5.767v9.966a5.767 5.767 0 0 1-5.767 5.767H7.017a5.767 5.767 0 0 1-5.767-5.767V7.017ZM7.017 2.75A4.267 4.267 0 0 0 2.75 7.017v9.966a4.267 4.267 0 0 0 4.267 4.267h9.966a4.267 4.267 0 0 0 4.267-4.267V7.017a4.267 4.267 0 0 0-4.267-4.267H7.017Z" fill="#fff"/></svg>
                  ${location.title}
                </div>
                <div class="info-window__info" style="${
                  location.additionalInfoCut ? "" : "display: none;"
                }">
                  <svg
                    width="24"
                    height="24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fillRule="evenodd" clipRule="evenodd" fill="#fff">
                      <path d="M1.25 12C1.25 6.086 6.086 1.25 12 1.25S22.75 6.086 22.75 12 17.914 22.75 12 22.75 1.25 17.914 1.25 12ZM12 2.75c-5.086 0-9.25 4.164-9.25 9.25s4.164 9.25 9.25 9.25 9.25-4.164 9.25-9.25S17.086 2.75 12 2.75Z" />
                      <path d="M11.246 17.75v-7.5h1.5v7.5h-1.5Z" />
                      <path d="M14.25 17.75h-4.5v-1.5h4.5v1.5ZM13.004 8a1 1 0 0 1-1 1h-.01a1 1 0 1 1 0-2h.01a1 1 0 0 1 1 1Z" />
                    </g>
                  </svg>
                  <div>${location.additionalInfoCut} <a href="${
              location.url
            }" class="underline hover:no-underline" type="button">${
              localization.Branches_MoreInfo
            }</a></div>
                </div>
                <div class="info-window__atm" style="${
                  location.branchWithAtm ? "" : "display: none;"
                }">
                  <svg class="icon" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 5.374A2.75 2.75 0 0 1 4 2.624h16a2.75 2.75 0 0 1 2.75 2.75v2a2.75 2.75 0 0 1-1.456 2.427l-.429-1.525c.237-.227.385-.547.385-.902v-2c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v2c0 .35.143.666.375.892l-.429 1.53A2.75 2.75 0 0 1 1.25 7.374v-2Zm3.609 2.263A2.75 2.75 0 0 1 7.507 5.63h8.973a2.75 2.75 0 0 1 2.647 2.006l2.88 10.247a2.75 2.75 0 0 1-2.647 3.494H4.637a2.75 2.75 0 0 1-2.648-3.492l2.87-10.247Zm2.648-.508a1.25 1.25 0 0 0-1.204.913l-2.87 10.247a1.25 1.25 0 0 0 1.204 1.587H19.36a1.25 1.25 0 0 0 1.204-1.588L17.683 8.04a1.25 1.25 0 0 0-1.203-.912H7.507ZM7.33 12.51l.382-2.601H9.23l-.382 2.6H7.33Zm-.2 1.355-.662 4.503h1.516l.663-4.503H7.13Z" fill="#fff"/></svg>
                  ${localization.Branches_BranchDetail_HasAtm}
                </div>
                <div class="info-window__time">
                  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd" clip-rule="evenodd" fill="#fff"><path d="M12 2.75c-5.106 0-9.25 4.144-9.25 9.25s4.144 9.25 9.25 9.25 9.25-4.144 9.25-9.25S17.106 2.75 12 2.75ZM1.25 12C1.25 6.066 6.066 1.25 12 1.25S22.75 6.066 22.75 12 17.934 22.75 12 22.75 1.25 17.934 1.25 12Z"/><path d="M12.38 6.76v4.85c0 .154.059.376.189.605.13.228.292.392.423.47l.002.001 3.744 2.234-.768 1.288-3.742-2.233h-.001c-.409-.243-.737-.624-.961-1.017-.225-.394-.386-.872-.386-1.348V6.76h1.5Z"/></g></svg>
                  ${location.openingHoursTime}
                </div>
              </div>
              <a href="${location.url}" class="btn btn--tertiary" type="button">${
              // eslint-disable-next-line no-nested-ternary
              type === "atms"
                ? localization.Branches_AtmDetail
                : location.isAdvisoryCenter
                ? localization.Branches_AdvisoryDetail
                : localization.Branches_BranchDetail
            }</a>
            </div>
          `;

            // Center the map on the clicked marker
            const markerPosition = marker.getPosition();
            map.panTo(markerPosition);

            infoWindow.setContent(content); // Nastavení obsahu info okna
            infoWindow.open(map, marker); // Otevření info okna při kliknutí na marker
          });

          // Get the show current location button element
          const showLocationBtn = document.getElementById("btn-atms-localization");
          if (showLocationBtn) {
            showLocationBtn.addEventListener("click", () => {
              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                  (position) => {
                    updateUserMarker({
                      lat: position.coords.latitude,
                      lng: position.coords.longitude,
                    });
                  },
                  (error) => {
                    console.error("Error getting user location:", error);
                  }
                );
              } else {
                console.error("Geolocation is not supported by this browser.");
              }
            });
          }

          return marker;
        });

        // Vytvoření a nastavení MarkerClustereru
        const markerCluster = new MarkerClusterer(map, markers, {
          styles: clusterStyles,
          gridSize: 60,
          maxZoom: 15,
        });

        if (showGeolocation) {
          // Získání aktuální polohy uživatele
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const userPos = {
                lat,
                lng,
              };

              updateUserMarker({ lat, lng });

              // Nastavení centra mapy na aktuální polohu uživatele a přiblížení
              map.setCenter(userPos);
              map.setZoom(12);
            },
            (error) => {
              console.error("Error getting user location:", error);
            }
          );

          if (lat && lng) {
            const userPos = {
              lat,
              lng,
            };

            updateUserMarker({ lat, lng });

            // Nastavení centra mapy na aktuální polohu uživatele a přiblížení
            map.setCenter(userPos);
            map.setZoom(12);
          }

          // Přidání všech markerů do hranic mapy
          // ! FIXME
          const closestMarkers = markers.slice(0, 5);
          const bounds = new window.google.maps.LatLngBounds();
          bounds.extend(closestMarkers?.getPosition());
          map.fitBounds(bounds);
        } else {
          const bounds = new window.google.maps.LatLngBounds();
          markers.forEach((marker) => {
            bounds.extend(marker.getPosition());
          });
          // Fit the map to the bounds
          map.fitBounds(bounds);
        }
      })
      .catch((error) => {
        // V případě chyby při načítání Google Maps API
        console.error("Chyba při načítání mapy:", error);
      });
  }, [items, TabType, isToggled]);

  return <div id="mapAtm" className="results-map" style={{ minHeight: "640px", width: "100%" }} />;
};

export default AtmMap;
